module.exports = __webpack_public_path__ + "img/6.2ba825c7.jpg";